import { render, staticRenderFns } from "./ModelRiskAnalytics.vue?vue&type=template&id=77a22b10&"
import script from "./ModelRiskAnalytics.vue?vue&type=script&lang=js&"
export * from "./ModelRiskAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports